enum ImageWidgetSourceType {
  SOCIAL_IMAGE_POST = 'social-image-post',
}

interface ImagesetItem {
  title: string
  caption: string
  alt: string
  source: string
  url: string
  id: number
  source_url?: string
  image?: {
    file?: File
    copyrightImage: {
      url: string
      source_url: string
      source: string
      copyright_file?: File | null
    }
  }
  buy3?: string
  blur: boolean
}

interface ImagesetWidget {
  flip: boolean
  images: ImagesetItem[]
}

export { ImageWidgetSourceType }

export type { ImagesetItem, ImagesetWidget }
